"use client"

import { useEffect, useRef } from 'react'
import { useWatchTexts, useWatchToken } from '@hooks/useWatched'
import toggleWatch from 'lib/watch/toggleWatch'
import { hasToken, isWatched, loadGuest, register, subscribe } from 'lib/watch/watchStore'

const BUTTON = '[data-watch]'

// Jeden kontroler serc obserwowania (CardWatchButton) dla całej strony: kliknięcia przez delegację,
// stan ze wspólnego magazynu przepisywany do aria-pressed. Karty dodane później (nawigacja w liście)
// są wykrywane przez MutationObserver.
export default function WatchController () {
    const token = useWatchToken()
    const texts = useWatchTexts()
    const t = useRef(texts)
    t.current = texts

    useEffect(() => {
        const buttons = () => document.querySelectorAll(BUTTON)
        const sync = () => {
            buttons().forEach(btn => {
                const on = String(isWatched(btn.dataset.watch))
                if (btn.getAttribute('aria-pressed') !== on) btn.setAttribute('aria-pressed', on)
            })
        }
        const scan = () => {
            if (hasToken()) buttons().forEach(btn => register(btn.dataset.watch))
            sync()
        }
        let frame = 0
        const observer = new MutationObserver(() => {
            cancelAnimationFrame(frame)
            frame = requestAnimationFrame(scan)
        })
        const onClick = (e) => {
            const btn = e.target.closest?.(BUTTON)
            if (btn) toggleWatch({ id: btn.dataset.watch, type: btn.dataset.watchType, opener: btn, t: t.current })
        }

        if (!hasToken()) loadGuest()
        scan()
        const unsubscribe = subscribe(sync)
        observer.observe(document.body, { childList: true, subtree: true })
        document.addEventListener('click', onClick)
        return () => {
            unsubscribe()
            observer.disconnect()
            cancelAnimationFrame(frame)
            document.removeEventListener('click', onClick)
        }
    }, [token])

    return null
}
